import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function PowerGeneration() {
  const [powerplants, setPowerplants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const plantsPerPage = 12;

  // Fetch plants from backend
  useEffect(() => {
    const fetchPlants = async () => {
      try {
        const res = await axios.get("https://backend-zkgn.onrender.com/api/plants");
        setPowerplants(res.data);
      } catch (err) {
        console.error("Failed to fetch plants:", err);
        toast.error("Failed to fetch plants");
      } finally {
        setLoading(false);
      }
    };
    fetchPlants();
  }, []);

  // Pagination calculations
  const indexOfLastPlant = currentPage * plantsPerPage;
  const indexOfFirstPlant = indexOfLastPlant - plantsPerPage;
  const currentPlants = powerplants.slice(indexOfFirstPlant, indexOfLastPlant);
  const totalPages = Math.ceil(powerplants.length / plantsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Delete a plant
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this plant?")) return;

    try {
      await axios.delete(`https://backend-zkgn.onrender.com/api/plants/${id}`);
      setPowerplants((prev) => prev.filter((plant) => plant.power_id !== id));
      toast.success("Plant deleted successfully");
    } catch (err) {
      console.error("Error deleting plant:", err);
      toast.error("Failed to delete plant");
    }
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="fw-bold text-tertiary mb-2">
          <strong>{powerplants.length}</strong> - Power Generation Plants Found
        </h5>
        <Link to="/addpowergenerationplant" className="btn btn-primary">
          Add Power Generation Plant
        </Link>
      </div>

      <div className="row">
        {currentPlants.map((plant) => (
          <div key={plant.power_id} className="col-lg-4 col-md-6 mb-4">
            <div className="card h-100 shadow-sm position-relative">
              <div className="card-body">
                <Link to={`/Powergenerationdashboard/${plant.genplant_name.replace(
                    /\s+/g,
                    "-"
                  )}/${plant.power_id}`} className="plant-link">
                  <h5 className="card-title fw-bold text-dark">{plant.genplant_name}</h5>
                </Link>
                <p className="mb-1">
                  <strong style={{ color: "#D84D10" }}>City:</strong> {plant.genplant_city}
                </p>
                <p className="mb-0">
                  <strong style={{ color: "#D84D10" }}>Contact:</strong> {plant.genplant_phone}
                </p>
              </div>

              <div className="position-absolute bottom-0 end-0 p-2 d-flex">
                <Link to={`/updatepowergenerationplant/${plant.genplant_name.replace(
                    /\s+/g,
                    "-"
                  )}/${plant.power_id}`} className="btn btn-link text-success p-0 me-3">
                  <i className="fa fa-edit"></i>
                </Link>
                <button onClick={() => handleDelete(plant.power_id)} className="btn btn-link text-danger p-0">
                  <i className="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="pagination-container d-flex justify-content-center my-3">
        <button className="pagination-btn btn btn-outline-secondary me-2" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Previous
        </button>

        {Array.from({ length: totalPages }, (_, idx) => (
          <button
            key={idx + 1}
            className={`pagination-btn btn me-1 ${currentPage === idx + 1 ? 'btn-primary text-white' : 'btn-outline-primary'}`}
            onClick={() => handlePageChange(idx + 1)}
          >
            {idx + 1}
          </button>
        ))}

        <button className="pagination-btn btn btn-outline-secondary ms-2" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Next
        </button>
      </div>

      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
}

export default PowerGeneration;
